import { draftel_codecs_pack_terkk$_bundle_paletapakovanja } from "./ter-draftel-codec-lib-terkk-bundle-paletapakovanja";
import { SPACE } from "../utils/frfr-string-consts";
import { terUtilsNumberRoundUp } from "./ter-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { SINGLE_PIECE_PER_NEXT_OPERATION_UNIT } from "./virtel-consts";
import tclocal from "./ter-consts-local-lib";
import { _getFromLibMaterijalLimSingleParam, _getParamsFromLibMaterijalLimParams } from "./ter-materijal-utils";
import { CEILING, ROUNDUP, XIF } from "../utils/excel-functions-utils";
import { terProtobompUtils_make_protobomp_manifest_terkk_latest, terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL } from "./ter-protobomp-utils";
import { protobomp_manipulator } from "../utils/frfr-protobomp-utils";


export const derDraftel_terkk_paletapakovanja_pripremi_pods_input_inherited_za_draftel = (virtel_k, virtel_m) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input_inherited = {
    ...draftel_codecs_pack_terkk$_bundle_paletapakovanja.default_pods_input_state(),
    // TODO
    /*
    msirinaspoljasnja: virtel_m.msirinaspoljasnja,
    duzinamodula: virtel_m.duzinamodula,
    // brojmodula: virtel_m.brojmodula, // ???
    */
    sifrakomore: virtel_k.sifrakomore,
    siframodula: virtel_m.siframodula,
  };
  return pods_input_inherited;
};



//
export const _derivat_terkk_paletapakovanja_izracunaj_za_step_2 = (state, pods_input) => {
  //
  /*
  const {

  } = pods_input;
  */
  const {
    pal_sirina,
    pal_duzina,
  } = state;
  //
  /*
  Proračun se radi na sledeći način:
  
  Daske Imamo po sirini i dužini kao i klocne koje su dimenzija 100x100x80
  Dužina dasaka po širini jednaka je pal_sirina
  Dužina dasaka po dužini jednaka je pal_duzina
  
  Proračun broja klocni računa se po sledećoj formuli:
  
  Broj klocni po dužini($pal_klocniduzina):
  =ROUND(pal_duzina/(100+600);0)
  
  Broj klocni po širini($pal_kolikoklocniduzinski):
  =ROUND(pal_sirina/(100+600);0)
  
  Proračun komada za dužinu je sledeći ($pal_kolikodasakaduzinski):
  IF $pal_sirina>$pal_duzina THEN ROUND($pal_duzina/(210+150);0) ELSE $Brojklocniduzina*2)
  
  Proračun komada za širinu je sledeći ($pal_kolikodasakaduzinski):
  IF $pal_dusina>$pal_sirina THEN ROUND($pal_sirina/(210+150);0) ELSE $Brojklocnisirina*2)
  */
  /*
  NJ 2024-12-27:
  Proverio sam dobru sam formulu poslao. Tačno kako u excellu tako je i prenešeno:
  =IF(I18>H18;CEILING(H18/(210+150);1);M172)- broj dasaka dužina
  =IF(H18>I18;CEILING(I18/(210+150);1);M182)- broj dasaka širina
  Gde su:
  I18 - Širina paleta
  H18 - Dužina palete
  */
  // NJ 2024-12-27 NAJNOVIJE:
  const pal_kolikoklocnisirinski = CEILING(pal_sirina / (100 + 600), 1);
  const pal_kolikoklocniduzinski = CEILING(pal_duzina / (100 + 600), 1);
  const pal_kolikodasakasirinski = XIF(pal_sirina > pal_duzina, CEILING(pal_duzina / (210 + 150), 1), pal_kolikoklocniduzinski * 2);
  const pal_kolikodasakaduzinski = XIF(pal_duzina > pal_sirina, CEILING(pal_sirina / (210 + 150), 1), pal_kolikoklocnisirinski * 2);
  return {
    pal_kolikoklocnisirinski,
    pal_kolikoklocniduzinski,
    pal_kolikodasakasirinski,
    pal_kolikodasakaduzinski,
  };
};


//
export const _derivat_terkk_paletapakovanja_pbnode_dirty_enrich = (pbnode_state_ref, protobomp_superdata, is_init) => {
  // DIRTY ENRICH
  // TODO ...props super superProps
  // console.log('item_ref, protobomp_superdata', item_ref, protobomp_superdata);
  const item = pbnode_state_ref;
  const family = item.pbnode_family;
  let povrsina = -1;
  let _cnc = null;
  let _naziv = null;
  let _materijal = '?'; // item.identmaterijala
  let _naziv_profil_komore_50_ili_70 = '?';
  let _naziv_tip_kadice = '?';
  let _tip_klizaca_abc = '?';
  let _tip_kadice = '?';
  let _strana_maske = '?';
  let _sufix = '?';
  let _visina_20_ili_35 = -1;
  /*
  Gde su: 

  */
  //
  const _mat_params = _getParamsFromLibMaterijalLimParams(item.identmaterijala);
  if (is_init === true) {
    if (typeof _mat_params.naziv === 'string') {
      item.naziv_materijala = _mat_params.naziv; // DIRTY
    } else {
      item.naziv_materijala = ''; // DIRTY
    }
  }
  /*
  const _tipmetalalima = _mat_params?.naziv_materijala;
  if (_tipmetalalima === "Prohrom") {
    _materijal = "SS";
  }
  if (_tipmetalalima === "Pocinkovani") {
    _materijal = "GS";
  }
  */
  //
  const {

  } = protobomp_superdata;
  //

  //
  if (true) {
    // sklop
    if (family === 'terkk$pal/SKLOP_PALETA') {
      // item.naziv = "???"; // DIRTY

    }
    //

    //
    //
  }
  // 
  if (povrsina > -1) {
    item.povrsina = terUtilsNumberRoundUp((povrsina / 1000000), 2); // konvertovana u m2 i zaokruzeno na 2 decimale // DIRTY
  }
  if (_cnc) {
    item.cnccrtez = _cnc; // DIRTY
  }
  if (_naziv) {
    item.naziv = _naziv; // DIRTY
  }
  //
  return item;
};


//
export const _derivat_terkk_paletapakovanja_izracunaj_za_step_protobomp = (state, pods_input) => {
  //
  const {

  } = pods_input;
  const {
    pal_sirina,
    pal_duzina,
    pal_kolikoklocniduzinski,
    pal_kolikoklocnisirinski,
    pal_kolikodasakaduzinski,
    pal_kolikodasakasirinski,
    pal_toplotnotretiranje,
    kolicina,
  } = state;

  // TODO
  const protobomp_superdata = {

  };

  //
  // _subform_arr
  let _arr = [];
  let _protobomp = protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$ramfuk"), protobomp_superdata);
  //
  //
  const _pbnode_dirty_enrich = _derivat_terkk_paletapakovanja_pbnode_dirty_enrich; // TODO
  // ----- kreiranje sklopova
  //
  const _sklop_uzor = {
  };
  let _temp_sklop;
  let _temp_pbnode;
  _temp_sklop = { // 1. odnosi se na sklop palete
    ..._sklop_uzor,
    pbnode_family: 'terkk$pal/SKLOP_PALETA',
    naziv: "PALETA-" + pal_sirina + "x" + pal_duzina,
    kolicina: kolicina,
    "operacija1": "OPSKL", // Operacija1: Sklapanje
    "rc1": "RCPAL", // Radni centar 1: RC-Palete
  };
  _temp_sklop.distinction_key = "terkk$PAL/SKLOP_PALETA"; // DIRTY
  _temp_sklop.pal_sirina = pal_sirina; // DIRTY
  _temp_sklop.pal_duzina = pal_duzina; // DIRTY
  _temp_sklop.pal_visina = 175; // DIRTY // Možemo da dodamo i visinu palete: 175mm, ona nam je za sada zakucana.
  _temp_sklop.pal_kolikoklocniduzinski = pal_kolikoklocniduzinski; // DIRTY
  _temp_sklop.pal_kolikoklocnisirinski = pal_kolikoklocnisirinski; // DIRTY
  _temp_sklop.pal_kolikodasakaduzinski = pal_kolikodasakaduzinski; // DIRTY
  _temp_sklop.pal_kolikodasakasirinski = pal_kolikodasakasirinski; // DIRTY
  _temp_sklop.pal_toplotnotretiranje = pal_toplotnotretiranje; // DIRTY
  //
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true }, 'sklop_paleta');
  const { created_tempkey: sklop_paleta } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  // ----- dodavanje primitivnih u sklopove
  //

  //
  if (true) { // 2. Odnosi se na materijal sklopa. Ovde treba da bude prikazana ukupna zapremina dasaka:
    const item = {
      tempkey: 2,
      naziv: "DRVENA GRADJA - DASKA, sirine 15-20cm - 4m ( 2 m3 )",
      // pbnode_family: 'terkk$pov/?',
      // kolicina: -1, //
      jm: tclocal.JM_M3,
      terkategorija: "M",
      // identcustom: pov_materijal_cev,
      identcustom: 'P000000000000409',
    };
    // Količina: pal_kolikodasakaduzinski*(210/1000)($pal_sirina/1000)(25/1000) + pal_kolikodasakasirinski*(210/1000)($pal_duzina/1000)(25/1000)
    item.kolicina = ROUNDUP((pal_kolikodasakaduzinski * (210 / 1000) * (pal_sirina / 1000) * (25 / 1000) + pal_kolikodasakasirinski * (210 / 1000) * (pal_duzina / 1000) * (25 / 1000)), 3); // DIRTY // Zaokruzujemo zapreminunu u m3 na 3 decimale (treca decimala je 1litar).
    //
    _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
    const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
    protobomp_manipulator.add(_protobomp, pbnode, sklop_paleta);
  }
  //
  if (true) { // 3. Odnosi se na materijal sklopa. Ovde treba da bude prikazana ukupna zapremina potrošenih greda za proizvodnju klocne, Jedna klocna ima zapreminu 0,0008m3 :
    const item = {
      tempkey: 3,
      naziv: "DRVENA GRADJA - GREDA, 10x8mm ( 6m )",
      // pbnode_family: 'terkk$pov/?',
      // kolicina: -1, //
      jm: tclocal.JM_M3,
      terkategorija: "M",
      // identcustom: pov_materijal_cev,
      identcustom: 'P000000000000410',
    };
    // Količina: ($pal_kolikoklocniduzinski*$pal_kolikoklocnisirinski)*0,0008
    item.kolicina = ROUNDUP(((pal_kolikoklocniduzinski * pal_kolikoklocnisirinski) * 0.0008), 3); // DIRTY // Zaokruzujemo zapreminunu u m3 na 3 decimale (treca decimala je 1litar).
    //
    _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
    const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
    protobomp_manipulator.add(_protobomp, pbnode, sklop_paleta);
  }

  //
  //
  return {
    svasta: {},
    // _arr,
    _protobomp,
  }; // TODO
};


// ---------- VIRBOM DERIVATS ----------

